/**
 * Helpers to merge relation state on the client
 */

const mergeById = (existing = [], incoming = []) => {
  const existing_by_id = new Map(existing.map((item) => [item.id, item]));
  const new_items = [];

  incoming.forEach((item) => {
    if (!item?.id) {
      return;
    }

    const prev = existing_by_id.get(item.id);

    if (prev) {
      existing_by_id.set(item.id, { ...prev, ...item });
    } else {
      new_items.push(item);
    }
  });

  return [...new_items, ...existing.map((item) => existing_by_id.get(item.id))];
};

export const setRelationState = (
  backendData,
  setBackendData,
  relationKey,
  data
) => {
  setBackendData((prev) => ({
    ...prev,
    relations: {
      ...prev.relations,
      [relationKey]: data,
    },
  }));
};

const updateRelation = (backendData, setBackendData, relationKey, updater) => {
  const current_relation = backendData.relations[relationKey] ?? {};
  const current_data = current_relation.data ?? [];

  setBackendData((prev) => ({
    ...prev,
    relations: {
      ...prev.relations,
      [relationKey]: {
        ...current_relation,
        data: updater(current_data),
      },
    },
  }));
};

/**
 * Updates or adds an item in the relation state.
 *
 * Beispiel:
 * updateRelationState(backendData, setBackendData, "bookings", { id: 123, amount: 99.99 });
 * // Aktualisiert das Booking mit id 123 oder fügt es hinzu, falls es nicht existiert.
 *
 * @param backendData
 * @param setBackendData
 * @param relationKey
 * @param data
 */
export const updateRelationState = (
  backendData,
  setBackendData,
  relationKey,
  data
) => {
  if (!data?.id) {
    return;
  }

  updateRelation(backendData, setBackendData, relationKey, (current) =>
    mergeById(current, [data])
  );
};

/**
 * Updates or ads multiple items in the relation state.
 *
 * @param backendData
 * @param setBackendData
 * @param relationKey
 * @param dataList
 */
export const updateRelationStateMany = (
  backendData,
  setBackendData,
  relationKey,
  dataList
) => {
  if (!Array.isArray(dataList) || dataList.length === 0) {
    return;
  }

  updateRelation(backendData, setBackendData, relationKey, (current) =>
    mergeById(current, dataList)
  );
};

export const setRelationSubKeyState = (
  backendData,
  setBackendData,
  relationKey,
  subKey,
  data
) => {
  setBackendData((prev) => {
    const relData = prev?.relations?.[relationKey] ?? {};

    return {
      ...prev,
      relations: {
        ...prev.relations,
        [relationKey]: {
          ...relData,
          [subKey]: data,
        },
      },
    };
  });
};
